import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React from "react";
import { Typography } from "@material-ui/core";
import { MobileCardItem, InputSearch, ContainerSearch, CanSwitch } from "../../../../";
import { makeStyles } from "@material-ui/styles";
import { useState } from "react";
var useStyles = makeStyles(function (theme) {
  return {
    searchContainer: {
      display: "flex",
      flexFlow: "row nowrap",
      alignItems: "center",
      height: "60px",
      paddingTop: "8px",
      position: "fixed",
      width: "100%",
      zIndex: "10",
      background: theme.palette.background["default"]
    },
    search: {
      borderRadius: "60px",
      margin: "0 8px"
    },
    content: {
      padding: "80px 0 12px 0",
      width: "100%"
    },
    m12: {
      margin: "12px"
    },
    defaultCard: {
      margin: "12px",
      padding: "8px 4px"
    }
  };
});

var MobileCampusUsersTabAllergies = function MobileCampusUsersTabAllergies(props) {
  var classes = useStyles();

  var _useState = useState(""),
      _useState2 = _slicedToArray(_useState, 2),
      value = _useState2[0],
      setValue = _useState2[1];

  var handleSearchChange = function handleSearchChange(event) {
    setValue(event.target.value);
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: classes.searchContainer
  }, /*#__PURE__*/React.createElement(InputSearch, {
    value: value,
    classes: classes.search,
    onChange: handleSearchChange,
    placeholder: "Buscar usuario"
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.content
  }, /*#__PURE__*/React.createElement(ContainerSearch, {
    search: value,
    searchParams: ["name", "allergies"],
    options: props.data,
    template: function template(option) {
      return /*#__PURE__*/React.createElement(CanSwitch, {
        role: props.role,
        coordinator: function coordinator() {
          return /*#__PURE__*/React.createElement(MobileCardItem, {
            template: "usersAllergyListStaffCoordinator",
            data: option,
            classes: classes.m12
          });
        },
        trainer: function trainer() {
          return /*#__PURE__*/React.createElement(MobileCardItem, {
            template: "usersAllergyListStaffTrainer",
            data: option,
            classes: classes.m12
          });
        }
      });
    },
    notFound: function notFound() {
      return /*#__PURE__*/React.createElement(MobileCardItem, {
        classes: classes.defaultCard
      }, /*#__PURE__*/React.createElement(Typography, {
        variant: "body1",
        align: "center"
      }, "No se han encontrado"));
    },
    empty: function empty() {
      return /*#__PURE__*/React.createElement(MobileCardItem, {
        classes: classes.defaultCard
      }, /*#__PURE__*/React.createElement(Typography, {
        variant: "body1",
        align: "center"
      }, "No hay opciones"));
    }
  })));
};

export { MobileCampusUsersTabAllergies };